module.exports = __webpack_public_path__ + "img/yingxiao01.9bdefe35.png";